import { render, staticRenderFns } from "./PrivateSchools.vue?vue&type=template&id=719bdfe7&"
import script from "./PrivateSchools.vue?vue&type=script&lang=js&"
export * from "./PrivateSchools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports